const breadCrumb = "Emitir Boletim ";

const routes = [
  {
    path: "/emitir-boletim-turma",
    name: "emitir-boletim-turma",
    meta: {
      breadCrumb: breadCrumb,
      requireAuth: false,
    },
    component: () =>
      import("@/views/EmitirBoletimTurma/EmitirBoletimTurmaHome.vue"),
  },
];

export default routes;
